import React from 'react';
import PropTypes from 'prop-types';
import Icon, { NAMES } from '@ifit/react-icons';

import { solidWhite } from '../../theme/colors';
import './index.css';

const GenderSelect = (props) => {
  return (
    <div className="gender-select">
      <div>
        <button onClick={ props.handleSelectFemale }>
          <Icon
            name={ NAMES.GENDER_FEMALE }
            color={ solidWhite }
            style={{ opacity: props.gender === 'female' ? 1 : 0.3 }}
          />
          <label>Female</label>
        </button>
      </div>
      <div>
        <button onClick={ props.handleSelectMale }>
          <Icon
            name={ NAMES.GENDER_MALE }
            color={ solidWhite }
            style={{ opacity: props.gender === 'male' ? 1 : 0.3 }}
          />
          <label>Male</label>
        </button>
      </div>
    </div>
  );
};

GenderSelect.propTypes = {
  gender: PropTypes.string,
  handleSelectFemale: PropTypes.func,
  handleSelectMale: PropTypes.func
};

export default GenderSelect;
